// extracted by mini-css-extract-plugin
module.exports = {"body":"_3f97542"};